import Vue from 'vue';
if (process.browser) {
  const device = require('vue-device-detector');
  Vue.use(device);
}
